import { Select, Space, Typography } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { FC } from 'react'

const { Text } = Typography

export const HistoSortConfigView: FC = () => {
  const { sortDirection, setSortDirection } = useHistogramConfiguration()
  return (
    <>
      {!!setSortDirection && (
        <Space align='center' size='small'>
          <Text strong>Sort:</Text>
          <Select
            options={[
              { value: 'asc', label: 'Ascending' },
              { value: 'desc', label: 'Descending' },
            ]}
            value={sortDirection}
            onChange={setSortDirection}
            style={{ width: 150 }}
          />
        </Space>
      )}
    </>
  )
}
